const mainState = {
    datosSession: {},
    statusToken: null,
}

export default mainState;
